// src/mocks/browser.js
import { setupWorker } from 'msw';
import { handlers } from './handlers';

// This configures a Service Worker with the given request handlers.
const allHandlers = handlers.map((handler) => handler.handlers()).flat();
export const worker = setupWorker(...allHandlers);
